import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/whatsapp";

const BOOKING_URL = "https://business.coressenglobal.com/";

const CalendlySection = () => {
  return (
    <section
      id="calendly"
      className="py-20 md:py-28 relative overflow-hidden"
    >
      {/* Background gradient */}
      <div
        className="absolute inset-0"
        style={{ background: "linear-gradient(180deg, #0a1628 0%, #1e3a5f 100%)" }}
      />
      {/* Glow accents */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full blur-3xl opacity-20 pointer-events-none" style={{ backgroundColor: "#3b82f6" }} />

      <div className="container px-4 relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-10"
        >
          <span className="text-xs md:text-sm font-semibold tracking-[0.3em] uppercase text-blue-400 block mb-4">
            Agendá tu Llamada
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
            Reservá tu{" "}
            <span
              className="italic bg-clip-text text-transparent"
              style={{ backgroundImage: "linear-gradient(135deg, #60a5fa 0%, #93c5fd 100%)" }}
            >
              Llamada Estratégica
            </span>
          </h2>
          <p className="text-sm md:text-base italic text-white/60 mt-5">
            *Sólo para marcas con amplia trayectoria que estén dispuestas a invertir en su crecimiento.
          </p>
        </motion.div>

        {/* Card */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="max-w-3xl mx-auto"
        >
          <div
            className="relative rounded-3xl p-8 md:p-12 border border-blue-400/40 bg-[#0a1628]/80 backdrop-blur-sm"
            style={{
              boxShadow: "0 0 60px hsl(217, 91%, 60% / 0.25), 0 0 120px hsl(217, 91%, 60% / 0.1)",
            }}
          >
            {/* Meta line */}
            <div className="flex items-center gap-3 text-xs md:text-sm tracking-[0.2em] uppercase mb-6">
              <span className="text-white/50 font-medium">Llamada de 30 min</span>
            </div>

            {/* Description */}
            <p className="text-lg md:text-xl text-white leading-relaxed mb-6">
              Agendá tu llamada de{" "}
              <span className="text-blue-400 font-semibold">30 minutos</span>{" "}
              para que conozcamos tu caso en profundidad y, si vemos que podemos ayudarte, te contamos cómo sería trabajar juntos. Y si no, te lo hacemos saber.
            </p>

            {/* Quote */}
            <div className="border-l-2 border-blue-400/60 pl-5 py-1 mb-10">
              <p className="italic text-white/70 leading-relaxed">
                Valoramos tu tiempo y el nuestro: reservá solo si tu compromiso con la excelencia es absoluto.
              </p>
            </div>

            {/* CTA */}
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group w-full flex items-center justify-center gap-3 px-8 py-5 rounded-full bg-gradient-to-r from-[#2563eb] to-[#3b82f6] text-white font-semibold tracking-[0.15em] uppercase shadow-[0_8px_30px_hsl(221,83%,53%/0.4)] hover:shadow-[0_12px_40px_hsl(221,83%,53%/0.6)] hover:scale-[1.01] transition-all duration-300"
            >
              Agendar Llamada
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </motion.div>

        {/* WhatsApp alternative */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="text-center mt-8"
        >
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-blue-400 hover:text-blue-300 transition-colors underline underline-offset-4"
          >
            ¿Preferís hablar con un asesor? Escribinos por WhatsApp.
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default CalendlySection;
